var _a;
import Immutable from 'seamless-immutable';
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { AppConstant } from 'constants/app.constant';
import { CATEGORY_DROPDOWN_KEYS, STUDENT_PERFORMANCE_AVERAGE_TYPE } from 'reports/sh/constants/sh.constant';
var getSHState = function (state) { return state[AppConstant.reduxResources.SH_STATE]; };
var initialState = Immutable({
    assignmentDistributedScoreCardAndTableSortInteraction: null,
    assignmentInteractionTimeCardAndTableSortInteraction: null,
    instructorId: null,
    patientInteractionTimeCardAndTableSortInteraction: null,
    scoreDistributedCardAndTableSortInteraction: null,
    studentAssignmentsDistributedScoreCardAndTableSortInteraction: null,
    studentAverageComparedIndexPercentage: 0,
    studentAveragePerformanceType: STUDENT_PERFORMANCE_AVERAGE_TYPE.DCE,
    studentInteractionTimeCardAndTableSortInteraction: null,
    studentPerformanceIndexPercentage: 0,
    weakestCategoriesCardAndChartInteraction: { selectedCategories: [CATEGORY_DROPDOWN_KEYS.SDC] },
    sectionId: null,
    courseId: null,
    isCoursesLoading: false,
    studentClassAveragePITMinutes: null,
    assignmentViewCJMMItemAndTabInteraction: null,
    courses: [],
    classConstructSummaryCardAndTableSortInteraction: null,
    cPRAAssignmentId: null,
    cPRAStudentId: null,
    studentDashboardCourseId: null
});
var prefixActionName = 'SH';
var setStudentPerformanceIndexPercentage = createAction("".concat(prefixActionName, "/SET_STUDENT_PERFORMANCE_INDEX_PERCENTAGE"));
var setPatientInteractionTimeCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_PATIENT_INTERACTION_TIME_CARD_AND_TABLE_SORT_INTERACTION"));
var setStudentInteractionTimeCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_INTERACTION_TIME_CARD_AND_TABLE_SORT_INTERACTION"));
var setAssignmentInteractionTimeCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_INTERACTION_TIME_CARD_AND_TABLE_SORT_INTERACTION"));
var setScoreDistributedCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_SCORE_DISTRIBUTED_CARD_AND_TABLE_SORT_INTERACTION"));
var setStudentAssignmentsDistributedScoreCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_ASSIGNMENTS_DISTRIBUTED_SCORE_CARD_AND_TABLE_SORT_INTERACTION"));
var setAssignmentDistributedScoreCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_DISTRIBUTED_SCORE_CARD_AND_TABLE_SORT_INTERACTION"));
var setWeakestCategoriesCardAndChartInteraction = createAction("".concat(prefixActionName, "/SET_WEAKEST_CATEGORIES_CARD_AND_CHART_INTERACTION"));
var setInstructorId = createAction("".concat(prefixActionName, "/SET_INSTRUCTOR_ID"));
var restoreState = createAction("".concat(prefixActionName, "/RESTORE"));
var setStudentAveragePerformanceType = createAction("".concat(prefixActionName, "/SET_STUDENT_AVERAGE_PERFORMANCE_TYPE"));
var setStudentAverageComparedIndexPercentage = createAction("".concat(prefixActionName, "/SET_STUDENT_AVERAGE_COMPARED_INDEX_PERCENTAGE"));
var setCourseId = createAction("".concat(prefixActionName, "/SET_COURSE_ID"));
var setSectionId = createAction("".concat(prefixActionName, "/SET_SECTION_ID"));
var setIsCoursesLoading = createAction("".concat(prefixActionName, "/SET_IS_COURSES_LOADING"));
var setStudentClassAveragePITMinutes = createAction("".concat(prefixActionName, "/SET_STUDENT_CLASS_AVERAGE_PIT_MINUTES"));
var setAssignmentViewCJMMItemAndTabInteraction = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_VIEW_CJMM_ITEM_AND_TAB_INTERACTION"));
var setCourses = createAction("".concat(prefixActionName, "/SET_COURSES"));
var setClassConstructSummaryCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_CLASS_CONSTRUCT_SUMMARY_CARD_AND_TABLE_SORT_INTERACTION"));
var setCPRAAssignmentId = createAction("".concat(prefixActionName, "/SET_CPRA_ASSIGNMENT_ID"));
var setCPRAStudentId = createAction("".concat(prefixActionName, "/SET_CPRA_STUDENT_ID"));
var setStudentDashboardCourseId = createAction("".concat(prefixActionName, "/SET_STUDENT_DASHBOARD_COURSE_ID"));
var actions = {
    restoreState: restoreState,
    setAssignmentDistributedScoreCardAndTableSortInteraction: setAssignmentDistributedScoreCardAndTableSortInteraction,
    setAssignmentInteractionTimeCardAndTableSortInteraction: setAssignmentInteractionTimeCardAndTableSortInteraction,
    setInstructorId: setInstructorId,
    setPatientInteractionTimeCardAndTableSortInteraction: setPatientInteractionTimeCardAndTableSortInteraction,
    setScoreDistributedCardAndTableSortInteraction: setScoreDistributedCardAndTableSortInteraction,
    setStudentAssignmentsDistributedScoreCardAndTableSortInteraction: setStudentAssignmentsDistributedScoreCardAndTableSortInteraction,
    setStudentAverageComparedIndexPercentage: setStudentAverageComparedIndexPercentage,
    setStudentAveragePerformanceType: setStudentAveragePerformanceType,
    setStudentInteractionTimeCardAndTableSortInteraction: setStudentInteractionTimeCardAndTableSortInteraction,
    setStudentPerformanceIndexPercentage: setStudentPerformanceIndexPercentage,
    setWeakestCategoriesCardAndChartInteraction: setWeakestCategoriesCardAndChartInteraction,
    setSectionId: setSectionId,
    setIsCoursesLoading: setIsCoursesLoading,
    setCourseId: setCourseId,
    setStudentClassAveragePITMinutes: setStudentClassAveragePITMinutes,
    setAssignmentViewCJMMItemAndTabInteraction: setAssignmentViewCJMMItemAndTabInteraction,
    setCourses: setCourses,
    setClassConstructSummaryCardAndTableSortInteraction: setClassConstructSummaryCardAndTableSortInteraction,
    setCPRAAssignmentId: setCPRAAssignmentId,
    setCPRAStudentId: setCPRAStudentId,
    setStudentDashboardCourseId: setStudentDashboardCourseId
};
var reducer = handleActions((_a = {},
    _a[actions.setStudentPerformanceIndexPercentage] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentPerformanceIndexPercentage', payload);
    },
    _a[actions.setPatientInteractionTimeCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'patientInteractionTimeCardAndTableSortInteraction', payload.data);
    },
    _a[actions.setStudentInteractionTimeCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentInteractionTimeCardAndTableSortInteraction', payload.data);
    },
    _a[actions.setAssignmentInteractionTimeCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentInteractionTimeCardAndTableSortInteraction', payload.data);
    },
    _a[actions.setScoreDistributedCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'scoreDistributedCardAndTableSortInteraction', payload.data);
    },
    _a[actions.setStudentAssignmentsDistributedScoreCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentAssignmentsDistributedScoreCardAndTableSortInteraction', payload.data);
    },
    _a[actions.setAssignmentDistributedScoreCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentDistributedScoreCardAndTableSortInteraction', payload.data);
    },
    _a[actions.setWeakestCategoriesCardAndChartInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'weakestCategoriesCardAndChartInteraction', payload.data);
    },
    _a[actions.setInstructorId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'instructorId', payload);
    },
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setStudentAveragePerformanceType] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentAveragePerformanceType', payload);
    },
    _a[actions.setStudentAverageComparedIndexPercentage] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentAverageComparedIndexPercentage', payload);
    },
    _a[actions.setCourseId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'courseId', payload);
    },
    _a[actions.setSectionId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'sectionId', payload);
    },
    _a[actions.setIsCoursesLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCoursesLoading', payload);
    },
    _a[actions.setStudentClassAveragePITMinutes] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentClassAveragePITMinutes', payload);
    },
    _a[actions.setAssignmentViewCJMMItemAndTabInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentViewCJMMItemAndTabInteraction', payload.data);
    },
    _a[actions.setCourses] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'courses', payload);
    },
    _a[actions.setClassConstructSummaryCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'classConstructSummaryCardAndTableSortInteraction', payload);
    },
    _a[actions.setCPRAAssignmentId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cPRAAssignmentId', payload);
    },
    _a[actions.setCPRAStudentId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cPRAStudentId', payload);
    },
    _a[actions.setStudentDashboardCourseId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentDashboardCourseId', payload);
    },
    _a), initialState);
var selectors = {
    getInstructorId: createSelector(getSHState, function (state) { return state.instructorId; }),
    getPatientInteractionTimeCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.patientInteractionTimeCardAndTableSortInteraction; }),
    getStudentInteractionTimeCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.studentInteractionTimeCardAndTableSortInteraction; }),
    getAssignmentInteractionTimeCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.assignmentInteractionTimeCardAndTableSortInteraction; }),
    getScoreDistributedCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.scoreDistributedCardAndTableSortInteraction; }),
    getStudentAssignmentsDistributedScoreCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.studentAssignmentsDistributedScoreCardAndTableSortInteraction; }),
    getAssignmentDistributedScoreCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.assignmentDistributedScoreCardAndTableSortInteraction; }),
    getStudentAverageComparedIndexPercentage: createSelector(getSHState, function (state) { return state.studentAverageComparedIndexPercentage; }),
    getStudentAveragePerformanceType: createSelector(getSHState, function (state) { return state.studentAveragePerformanceType; }),
    getStudentPerformanceIndexPercentage: createSelector(getSHState, function (state) { return state.studentPerformanceIndexPercentage; }),
    getWeakestCategoriesCardAndChartInteraction: createSelector(getSHState, function (state) { return state.weakestCategoriesCardAndChartInteraction; }),
    getSectionId: createSelector(getSHState, function (state) { return state.sectionId; }),
    getCourseId: createSelector(getSHState, function (state) { return state.courseId; }),
    getIsCoursesLoading: createSelector(getSHState, function (state) { return state.isCoursesLoading; }),
    getStudentClassAveragePITMinutes: createSelector(getSHState, function (state) { return state.studentClassAveragePITMinutes; }),
    getAssignmentViewCJMMItemAndTabInteraction: createSelector(getSHState, function (state) { return state.assignmentViewCJMMItemAndTabInteraction; }),
    getCourses: createSelector(getSHState, function (state) { return state.courses; }),
    getClassConstructSummaryCardAndTableSortInteraction: createSelector(getSHState, function (state) { return state.classConstructSummaryCardAndTableSortInteraction; }),
    getCPRAAssignmentId: createSelector(getSHState, function (state) { return state.cPRAAssignmentId; }),
    getCPRAStudentId: createSelector(getSHState, function (state) { return state.cPRAStudentId; }),
    getStudentDashboardCourseId: createSelector(getSHState, function (state) { return state.studentDashboardCourseId; })
};
export { actions as shActions, reducer as shReducer, selectors as shSelectors };
export { initialState as shInitialState };
